export default __webpack_public_path__ + "static/media/image_2text.0f2fffae.png";